export default "__VITE_ASSET__BBtAtw5k__"